import { render, staticRenderFns } from "./AccountChangePassword.vue?vue&type=template&id=b6f8b81a&scoped=true&"
import script from "./AccountChangePassword.vue?vue&type=script&lang=js&"
export * from "./AccountChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./AccountChangePassword.vue?vue&type=style&index=0&id=b6f8b81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f8b81a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
